import type { KalturaAsset } from '@kaltura-ott/ott-client-types';

import { KalturaAssetDto } from '../../phoenix/composed';

import type { AdditionalData } from './tvpil';
import { MediaType, tvpil } from './tvpil';
import type { EntitiesType } from './types';

// Direct mapping of `MediaType` tvpil type
export type RhinoAssetType = keyof typeof rhinoAssetTypeToMediaTypeMap;

const rhinoAssetTypeToMediaTypeMap = {
  episode: MediaType.Episode,
  movie: MediaType.Movie,
  series: MediaType.Series,
  linear: MediaType.Linear,
  recording: MediaType.Program,
  program: MediaType.Program,
  season: MediaType.Season,
  package: MediaType.Package,
  person: MediaType.Person,
  logo: MediaType.Logo,
  link: MediaType.in_application_link_asset,
} as const;

const mediaTypeToRhinoAssetType = Object.fromEntries(
  Object.entries(rhinoAssetTypeToMediaTypeMap).map(([key, value]) => [value, key]),
) as Record<MediaType, RhinoAssetType>;

export function convertRhinoAssetTypeToMediaType(assetType: RhinoAssetType): MediaType {
  return rhinoAssetTypeToMediaTypeMap[assetType];
}

export function convertMediaTypeToRhinoAssetType(assetType: MediaType): RhinoAssetType {
  return mediaTypeToRhinoAssetType[assetType];
}

/**
 * Creates tvpil type from raw phoenix response
 * since raw asset is compatible with Client Lib asset
 */
export function convertKalturaAssetToTvpil(asset: KalturaAssetDto, data?: AdditionalData): EntitiesType | undefined {
  const assetType = tvpil.assetToType(asset as unknown as KalturaAsset, data);

  if (assetType) {
    return tvpil.creatorEntityStore(assetType);
  }

  return undefined;
}
